import { patch } from '..';

const updateAssignee = (ticketId: string, assignee: string) => patch(`assets/tickets/${ticketId}`, {
  assignee,
});

export default updateAssignee;
